import { SELECT_TAGS, SHOW_MORE } from '../constants/goal-show'

export const gaMiddleware = sendGaEvent => () => next => action => {
  try {
    switch (action.type) {
      case SELECT_TAGS:
        const joinedTags = action.tags.map(({ value }) => value).join(',')
        sendGaEvent({ action: `SELECT_TAGS/${joinedTags}`, label: 'center' })
        break
      case SHOW_MORE:
        sendGaEvent({ action: `SHOW_MORE/${action.title}`, label: 'center' })
        break
      default:
        break
    }
    return next(action)
  } catch (error) {
    next(action)
  }
}
